import React from 'react';
import loaderimg from '../images/loader/loader-img.png';

interface GenerateLoaderProps {
    loading: boolean;
}

const GenerateLoader: React.FC<GenerateLoaderProps> = ({ loading }) => {    
    return (
        <div className={`full-screen-loader ${loading ? 'flex' : 'hidden'}`}>
            <div className="full-loader">
                <img src={loaderimg} alt="Loader" />
                <div></div>
                <div></div>
            </div>
        </div>
    );
};

export default GenerateLoader;
